import { Component, inject } from '@angular/core';
import { PageComponent } from '@tytapp/common';
import { UserService } from '@tytapp/user';
import { ApiHowToWatchEntry, PagesApi } from '@tytapp/api';
import { HostApi } from '@tytapp/common';
import { BillingService } from '@tytapp/billing';

@Component({
    selector: 'app-how-to-watch',
    templateUrl: './how-to-watch.component.html',
    styleUrls: ['./how-to-watch.component.scss']
})
export class HowToWatchComponent extends PageComponent {
    private userService = inject(UserService);
    private pagesApi = inject(PagesApi);
    private hostApi = inject(HostApi);

    table: ApiHowToWatchEntry[];

    display = {
        null: '',
        free: 'Free',
        tyt_plus_exclusive: 'TYT Plus Exclusive',
        selected_shows: 'Selected Shows',
        platform_subscription_required: 'Platform Subscription Required'
    };

    get billingEnabled() {
        return this.hostApi.capabilities.includes('web_billing:membership')
            || this.hostApi.capabilities.includes('platform_billing:membership');
    }

    async init() {
        this.pageTitle = 'How To Watch';

        this.table = await this.pagesApi.getHowToWatchPage().toPromise();
    }

    get joinUrl() {
        return `/join/membership`;
    }

    get notMember() {
        return !this.userService.entitled;
    }

    locked(value: string) {
        return value === 'tyt_plus_exclusive';
    }
}
